import type { SubscriptionPaymentMethod } from '@houzy/schemas/partner-management/partner-subscription-management';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { subscriptionUnvalidatedTitle } from '../labels';

export type UnverifiedAlertProps = {
    paymentMethod: SubscriptionPaymentMethod;
};

export function UnverifiedAlert({ paymentMethod }: UnverifiedAlertProps): ReactElement {
    const { t } = useTranslation();

    return (
        <Alert severity="info">
            <AlertTitle>{subscriptionUnvalidatedTitle(t, paymentMethod)}</AlertTitle>
            <Typography variant="body2">
                <Trans i18nKey="SETTINGS.SUBSCRIPTION.UNVERIFIED.BODY" components={{ strong: <strong /> }} />
            </Typography>
        </Alert>
    );
}
